import bryanPicture from '/assets/sounds/img/brayn.jpeg'
import vanHalenPicure from '/assets/sounds/img/van_halen.jpeg'
import cyndiPicure from '/assets/sounds/img/cyndi.jpeg'
import journeyPicture from '/assets/sounds/img/journey.jpeg'


export const DataPlayer = [
  {
    title: 'Jump',
    author: 'Van Halen',
    picture: vanHalenPicure,
    player: '/assets/sounds/audio04.mp4'
  },

  {
    title: "Don't Stop Believin",
    author: 'Journey',
    picture: journeyPicture,
    player: "/assets/sounds/audio03.mp4"
  },

  {
    title: "Summer of '69",
    author: "Bryan Adams",
    picture: bryanPicture,
    player: "/assets/sounds/audio01.mp4"
  },

  {
    title: "Girls Just Want",
    author: "Cyndi Louper",
    picture: cyndiPicure,
    player: "/assets/sounds/audio02.mp4"
  }

]